<template>
<div class="animated fadeIn mt-5">
  <form enctype="multipart/form-data" v-on:submit="validateBeforeSubmit($event,false)">
    <div class="row">
      <div class="col-md-6">
        <b-card>
          <div slot="header">
            <strong>Actividade</strong>
          </div>
          <b-form-fieldset label="Nome">
            <b-form-input type="text" name="name" v-model="item.name" placeholder="Nome" v-validate="{ required: true }" :state="validateState('name')" data-vv-validate-on="change" ></b-form-input>
            <b-form-invalid-feedback>
              {{ errors.first('name') }}
            </b-form-invalid-feedback>
          </b-form-fieldset>
          <b-form-fieldset label="Preço">
            <b-form-input type="text" name="price" v-model="item.price" placeholder="Preço" v-validate="{ required: true }" :state="validateState('price')" data-vv-validate-on="change" ></b-form-input>
            <b-form-invalid-feedback>
              {{ errors.first('price') }}
            </b-form-invalid-feedback>
          </b-form-fieldset>



          <div slot="footer">
            <div class="row">
              <div class="col-sm-3">
                <router-link :to="{name:baseRoute + '.index'}" size="sm" variant="danger"><i class="fa fa-ban"></i> Cancelar</router-link>

              </div>
              <div class="col-sm-9 text-right">
                <b-button type="submit" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar</b-button>
                <b-button type="button" v-on:click="validateBeforeSubmit($event,true)" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar e fechar</b-button>
              </div>
            </div>
          </div>
        </b-card>
      </div>
      <!--/.col-->
      <div class="col-md-6">

      </div>
      <!--/.col-->
    </div>
  </form>

</div>
</template>

<script>
export default {
  name: 'MembershipEdit',
  props: ['id'],
  data() {
    return {
      url: 'membershiptypes',
      baseRoute: 'membershiptypes',
      showTeam: false,
      showPassword: false,
      countries: [],
      regions: [],
      item: {
        name: '',
        state: 1,
        price: null,
      }
    }
  },
  methods: {
    validateBeforeSubmit(evt, close) {
      evt.preventDefault()
      console.log('check validation')
      this.$validator.validateAll().then((result) => {
        console.log('validation results:', result)
        if (result) {
          console.log('all fields ok. submit')
          this.submit(evt, close)
          return
        }
        this.$bvToast.toast('Tem campos inválidos', { autoHideDelay: 5000, variant: 'danger', solid: true})
      })
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref)
      }
      return null
    },
    submit(e, close) {
      e.preventDefault()
      var data = {
        data: this.item
      }
      if (this.item.id) {
        this.axios.put(this.url + '/' + this.item.id, data)
          .then(response => {
            this.item = response.data.data
            this.$bvToast.toast('item gravado com sucesso', { autoHideDelay: 5000, variant: 'success', solid: true})
            if (close) {
              this.$router.push({
                name: this.baseRoute + '.index'
              })
            }
          })
          .catch(response => {
            this.$bvToast.toast('Não foi possivel gravar', { autoHideDelay: 5000, variant: 'danger', solid: true})
          })
      } else {
        this.axios.post(this.url, data)
          .then(response => {
            this.item = response.data.data
            this.$bvToast.toast('item gravado com sucesso', { autoHideDelay: 5000, variant: 'success', solid: true})
            this.$router.push({
              name: this.baseRoute + '.edit',
              params: {
                id: this.item.id
              }
            })
          })
          .catch(response => {
            this.$bvToast.toast('Não foi possivel gravar', { autoHideDelay: 5000, variant: 'danger', solid: true})
          })
      }
    }
  },
  created() {
    var id = this.$route.params.id
    if (typeof id !== 'undefined') {
      this.axios.get(this.url + '/' + id)
        .then(response => {
          this.item = response.data.data
          this.item.settings = {
            limits: {
              max: 48,
              regions: [],
              gender: {
                m: 50,
                f: 50
              },
              veterans: {
                veterans: 50,
                new: 50
              }
            }
          }
        })
        .catch(response => {          
          this.$bvToast.toast('Este tipo não existe', { autoHideDelay: 5000, variant: 'danger', solid: true})
          this.$router.push({
            name: this.baseRoute + '.index'
          })
        })
    } else {
    }
    this.axios.get('regions/lst').then(response => {
      this.regions = response.data.data
    })
  }
}
</script>
